import { render, staticRenderFns } from "./classRoom.vue?vue&type=template&id=01213e4a&"
import script from "./classRoom.vue?vue&type=script&lang=js&"
export * from "./classRoom.vue?vue&type=script&lang=js&"
import style0 from "./classRoom.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports